module.exports = __webpack_public_path__ + "img/61.3cd927b6.png";